import { ICustomizeTableColumn } from 'types/listsTypes';

export enum EOrdersStatuses {
  Pending = 'pending',
  Shipped = 'shipped',
  RequestReturn = 'request_return',
  ReturnCompleted = 'return_completed',
}

export interface IOrder {
  address1: string,
  address2: string,
  buyerEmail: string,
  carrierCode: any,
  city: string,
  country: string,
  createdDate: string,
  date: string,
  firstName: string,
  id: number,
  isEligible: boolean,
  lastName: string,
  orderId: string,
  paymentStatus: string,
  phoneNumber: null,
  price: number,
  productId: string,
  quantity: string,
  sellSiteOrderId: string,
  sellSiteOrderName: string,
  state: string,
  status: EOrdersStatuses,
  trackingNumber: any,
  trackingNumberDate: any,
  trackingUrl: any,
  transactionId: any,
  userId: number,
  variantId: string,
  withdrawTransactionId: any,
  zipCode: string,
  estimatedArrival: string,
  autodsUserId: string,
  invoicedLogoUri: string,
  orderPageUrl: string,
  product: {
    product: {
      title: string,
      url: string,
      mainPictureUrl: {
        url: string,
      }
    }
  }
  user: {
    autodsUserId: string,
  }
  amount: number,
  fullName: string,
}

export const defaultOrdersTableSettings: ICustomizeTableColumn[] = [
  { title: '', dataIndex: 'imageUrl', isFixed: true, isChecked: true },
  { title: 'Product Name', dataIndex: 'title', isFixed: true, isChecked: true },
  { title: 'Date', dataIndex: 'createdDate', isFixed: true, isChecked: true },
  { title: 'Order Status', dataIndex: 'status', isFixed: true, isChecked: true },
  { title: 'Amount', dataIndex: 'amount', isFixed: true, isChecked: true },
  { title: 'Payments', dataIndex: 'eligible', isFixed: true, isChecked: true },
  { title: 'Customizable Branding', dataIndex: 'customizableBranding', isChecked: true },
  { title: 'Source', dataIndex: 'source', isChecked: true },
  { title: 'Item ID', dataIndex: 'productId', isChecked: true },
  { title: 'Dropshipper Name', dataIndex: 'firstName', isChecked: true },
  { title: 'Customer', dataIndex: 'customer', isChecked: true },
  { title: 'Address', dataIndex: 'address1', isChecked: true },
  { title: 'Order ID', dataIndex: 'orderId', isChecked: true },
  { title: 'Estimated Arrival', dataIndex: 'estimatedArrival', isChecked: false },
  { title: '', dataIndex: 'empty', isChecked: true },
];
